import Tooltip from './chart-tooltip.component';
export default Tooltip;
